import { Typography } from "@mui/material";
import { Span } from "../Typography";

interface IRequiredFieldLabel {
  label: string;
}

const RequiredFieldLabel = ({ label }: IRequiredFieldLabel) => {
  return (
    <>
      {label}{" "}
      <Typography component={"span"} className="required-field" color={"error"}>
        *
      </Typography>
    </>
  );
};

export default RequiredFieldLabel;
